import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MeasurementCalc from './measurement-calc/MeasurementCalc';
import Instructions from './instructions/Instructions';
import Information from './information/Information';
import Signout from '../shared/Signout';

const Authenticated: React.FC = () => (
  <Routes>
    <Route path="/" element={<MeasurementCalc />} />
    <Route path="/finishLogin" element={<Navigate to="/" />} />
    <Route path="/instructions" element={<Instructions />} />
    <Route path="/information" element={<Information />} />
    <Route path="/signout" element={<Signout />} />
    <Route path="/auth" element={<Navigate to="/" />} />
  </Routes>
);

export default Authenticated;
